module.exports = __webpack_public_path__ + "static/mondays-results-bac08930586008c9bccf9d9a27735dbd.svg";